import { useSelector } from '../context';
import { selectNetworkPolicies } from '../selectors';

export function useNetworkPolicies() {
  return useSelector(selectNetworkPolicies);
}
